export const getMeta = (metaName) => {
    const metas = document.getElementsByTagName('meta');

    return (
        Array.from(metas)
            .find((meta) => meta.getAttribute('name') === metaName)
            ?.getAttribute('content') || ''
    );
};
